<div class="awaiting-contact">
  <div class="container text-center">
    <div class="logo">
      <img src="../../../../assets/logo/favicon.svg" alt="" />
    </div>
    <div class="page-img w-100 text-center">
      <img src="../../../../assets/ico/awaiting-contact.svg" alt="" />
    </div>
    <div class="description">
      <p>
        Seu pedido foi recebido! <br />
        Aguarde o contato da nossa equipe comercial.
      </p>
    </div>
    <div class="help-link">
      <a href="#">Precisa de ajuda?</a>
    </div>
  </div>
</div>
